import React, {useEffect } from "react";
import queryString from 'query-string'
import { Spinner } from 'reactstrap';
import justcastApi from '../api/justcast'

export default function FlodeskCallback(props) {
  const values = queryString.parse(props.location.search);
  const { code, state } = values;

  useEffect(() => {
    if(code && state) {
      justcastApi.put(`/v2/flodesk_connection_requests/${state}.json`, {
        auth_code: code
      })
      .then(() => {
        window.location = "/connections";
      })
      .catch((err) => {
        // could be code has expired
        console.log(err)
      })
    }
  }, [code, state])

  if(code && state) {
    return <Spinner/>
  }

  return null;
}
